import { Component, OnInit } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/storage';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { TicketService } from '../../serivce/ticket.service';

@Component({
  selector: 'app-ticket-edit-dialog',
  templateUrl: './ticket-edit-dialog.component.html',
  styleUrls: ['./ticket-edit-dialog.component.css']
})
export class TicketEditDialogComponent implements OnInit {

  constructor(private storage: AngularFireStorage, private spinner: NgxSpinnerService, private service: TicketService, private toastr: ToastrService,
    private router: Router, private route: ActivatedRoute) { }
  model = {
    Id: 0,
    Title: '',
    Content: '',
    TypeTicket: 1,
    Img: '',
    ContentFeedback: ''
  }
  fb;
  downloadURL: Observable<string>;
  ngOnInit() {
    debugger
    this.model.Id = parseInt(this.route.snapshot.params['Id'])
    this.model.Title = this.route.snapshot.params['Title']
    this.model.Content = (this.route.snapshot.params['Content'])
    this.model.TypeTicket = parseInt(this.route.snapshot.params['TypeTicket'])
    this.model.ContentFeedback = (this.route.snapshot.params['ContentFeedback'])
    this.fb = this.route.snapshot.params['Img'];
    if (this.fb == null || this.fb == "null") {

      $('#img').attr("src", "https://www.lifewire.com/thmb/P856-0hi4lmA2xinYWyaEpRIckw=/1920x1326/filters:no_upscale():max_bytes(150000):strip_icc()/cloud-upload-a30f385a928e44e199a62210d578375a.jpg");
    }
    else {
      $('#img').attr("src", this.route.snapshot.params['Img']);
    }
 
  }
  onFileSelected(event) {
    this.spinner.show();
    var n = Date.now();
    const file = event.target.files[0];
    const filePath = `RoomsImages/${n}`;
    const fileRef = this.storage.ref(filePath);
    const task = this.storage.upload(`RoomsImages/${n}`, file);
    task
      .snapshotChanges()
      .pipe(
        finalize(() => {
          this.downloadURL = fileRef.getDownloadURL();
          this.downloadURL.subscribe(url => {
            if (url) {
              this.fb = url;
              $('#img').attr("src", url);
              this.spinner.hide();
            }
          });
        })
      )
      .subscribe(url => {
      });
  }
  onSubmit() {
    debugger
    this.spinner.show();
    this.model.Img = this.fb;
    this.service.editTicket(this.model).subscribe(res => {
      this.spinner.hide();
      if (res.status == 2) {
        this.toastr.success(res.content, "Thành công");
        this.router.navigateByUrl('/ticket');
      }
      else {
        this.toastr.error(res.content, "Thất bại");
      }
    })
  }
}
